// Derivation of the per-row "has any contact" signal for the Client List delete guard (IGNITE-597).
// Mirrors the existing invoicesV2 -> hasInvoices logic in ClientsPage.tsx: one company-wide fetch,
// grouped by client id. Counts contacts of ALL statuses (active + inactive) — an inactive contact is
// still a real client_contact row that would block the client hard-delete.

type ClientContactsConnection =
	| {
			edges: Array<{node: {client: {id: string} | null} | null} | null> | null;
	  }
	| null
	| undefined;

export function buildClientIdsWithContacts(clientContacts: ClientContactsConnection): Set<string> {
	return new Set<string>(
		(clientContacts?.edges ?? []).map(edge => edge?.node?.client?.id).filter((id): id is string => id != null)
	);
}

export function computeClientHasContacts(
	clientId: string,
	clientIdsWithContacts: Set<string>,
	contactsFeatureOn: boolean
): boolean {
	return contactsFeatureOn && clientIdsWithContacts.has(clientId);
}
